import { action, observable } from 'mobx'

import Ds from './ds'

class Partners {
  @observable data = []
  @observable all = []
  @observable notes = []
  @observable tasks = []
  @observable partnersCount = 0
  @observable details = {
    id: 0,
    firstName: '',
    lastName: '',
    title: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    partnerCode: '',
    partnerTypeName: '',
    partnerCompanyName: ''
  }
  @observable partnerCompanies = []

  @observable ds = new Ds()

  @action countPartners() {
    let query = `{ partnerCount( organizationId: ${ localStorage.getItem('userOrganizationId') }, hash: "${ localStorage.getItem('userHash') }") }`
    console.log(query)
    this.ds.query(query, (data) => {
      this.partnersCount = data.partnerCount
      return this.partnersCount
    })
  }

  @action loadAllPartnerCompanies() {
    let query = `{
      partnerCompanies(
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        name
      }
    }`

    this.ds.query(query, (data) => {
      this.partnerCompanies = data.partnerCompanies
    })
  }

  @action loadAllOrganizationPartners(orgId, callback) {
    let query = `{
      partners(
        organizationId: ${ orgId },
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        partnerCompanyId
        firstName
        lastName
        address
        city
        state
        zipCode
        email
        phone
        partnerCode
      }
    }`

    console.log(query)
    this.ds.query(query, (data) => {
      this.data = data.partners.map((partner) => {
        //partner.partnerCompanyName = partner.partnerCompany.name
        partner.fullName = partner.firstName + ' ' + partner.lastName
        partner.name = partner.firstName + ' ' + partner.lastName
        partner.fullAddress = partner.address + ' ' + partner.city + ' ' + partner.state + ' ' + partner.zipCode
        return partner
      })

      if (callback) {
        return callback(this.data)
      }
    })
  }

  @action loadPartner(id, callback) {
    let query = `{
      partners(
        id: ${ id },
        hash: "${ localStorage.getItem('userHash') }"
      ) {
          id
          partnerCompanyId
          partnerTypeId
          firstName
          lastName
          partnerCode
          address
          city
          state
          zipCode
          email
          phone
        }
      }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (data.partners.length > 0) {
        console.log('setting details')
        this.details = data.partners[0]

        if (callback) {
          callback(this.details)
        }
      }
    })
  }

  @action updatePartner(partner, callback) {
    this.ds.query(`mutation { updatePartner(
      id: ${ partner.id },
      organizationId: ${ partner.organizationId },
      partnerCompanyId: ${ partner.partnerCompanyId },
      partnerTypeId: ${ partner.partnerTypeId },
      firstName: "${ partner.firstName }",
      lastName: "${ partner.lastName }",
      partnerCode: "${ partner.partnerCode }",
      address: "${ partner.address }",
      city: "${ partner.city }",
      state: "${ partner.state }",
      zipCode: "${ partner.zipCode }",
      email: "${ partner.email }",
      phone: "${ partner.phone }",
      hash: "${ localStorage.getItem('userHash') }"
      ) { id }}`, (data) => {
      this.loadAllOrganizationPartners(partner.organizationId)
      if (callback) {
        callback()
      }
    })
  }

  @action selectPartnerType(value) {
    document.getElementById('partnerCompany_Type').value = value
  }

  /*
  @action loadCompanyPartner(id) {
    this.ds.query(`{
      partners(id: ${ id }) {
        id
        firstName
        lastName
        title
        address
        city
        state
        zipCode
        partnerCode
        partnerType {
          name
          partnerCompany {
            name
          }
        }
      }
    }`, (data) => {
      if (data.partners.length > 0) {
        this.details = data.partners[0]
      }
    })
  }
  */

  @action loadPartnerCompanies() {
    let query = `{
      partnerCompanies(
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        name
        partnerTypes {
          id
          name
        }
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (data.partnerCompanies.length > 0) {
        this.all = data.partnerCompanies
      }
    })
  }

  @action newPartner(row, callback) {
    let query = `mutation {
      addPartner(
        organizationId: ${ row.organizationId },
        partnerCompanyId: ${ row.partnerCompanyId },
        partnerTypeId: ${ row.partnerTypeId },
        partnerCode: "${ row.partnerCode }",
        firstName: "${ row.firstName }",
        lastName: "${ row.lastName }",
        address: "${ row.address }",
        city: "${ row.city }",
        state: "${ row.state }",
        zipCode: "${ row.zipCode }",
        email: "${ row.email }",
        phone: "${ row.phone }",
        hash: "${ localStorage.getItem('userHash') }"
      ) { id } }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.loadAllOrganizationPartners(row.organizationId)
      if (callback) {
        callback(data)
      }
    })
  }

  @action deletePartner(id, organizationId) {
    this.ds.query(`mutation { deletePartner(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllOrganizationPartners(organizationId)
    })
  }

  /**
   * Notes
   **/
   @action loadPartnerNotes(id, hash) {
     let query = `{
       partnerNotes(
         partnerId: ${ id },
         hash: "${ localStorage.getItem('userHash') }"
       ) {
         id
         note
         createdAt
         user {
           firstName
           lastName
         }
       }
     }`

     console.log(query)

     this.ds.query(query, (data) => {
       this.notes = data.partnerNotes.map((note) => {
         note.userFullName = note.user.firstName + ' ' + note.user.lastName
         let cd = new Date(note.createdAt)
         note.formattedCreatedDate =   ('0' + (cd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (cd.getUTCDate())).slice(-2) + '-' + cd.getUTCFullYear()
         return note
       })
     })
  }

  @action loadPartnerNote(id, callback) {
    let query = `{
      partnerNotes(
        id: ${ id },
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        note
        userId
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (data.partnerNotes.length > 0) {
        this.noteDetail = data.partnerNotes[0]
        callback(data.partnerNotes[0])
      }
    })
  }

  @action addPartnerNote(row, callback) {
    let query = `mutation {
      addPartnerNote(
        note: "${ row.note }",
        partnerId: ${ row.partnerId },
        userId: ${ row.userId },
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        partnerId
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.loadPartnerNotes(data.addPartnerNote.partnerId, row.hash)

      if (callback) {
        callback(data)
      }
    })
  }

  @action updatePartnerNote(row, callback) {
    const query = `mutation {
      updatePartnerNote(
        id: ${ row.id },
        note: "${ row.note }",
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        partnerId
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.loadPartnerNotes(data.updatePartnerNote.partnerId, row.hash)
      if (callback) {
        callback(data)
      }
    })
  }

  @action deletePartnerNote(id, partnerId, hash) {
    this.ds.query(`mutation {
      deletePartnerNote(
        id: ${ id },
        hash: "${ hash }"
      ) { id }
    }`, (data) => {
      this.loadPartnerNotes(partnerId, hash)
    })
  }

  /**
   * Tasks
   **/
  @action loadPartnerTask(id, callback) {
    let query = `{
      partnerTasks(
        id: ${ id },
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        userId
        assignedUserId
        assignedUser {
          firstName
          lastName
        }
        task
        dueDate
        taskPriorityId
        taskPriority {
          name
        }
        taskStateId
        taskState {
          name
        }
        partner {
            firstName
            lastName
            phone
            email
        }
      }
    }`
    console.log(query)
    this.ds.query(query, (data) => {
      if (data.partnerTasks.length > 0) {
        let task = data.partnerTasks[0]

        task.assignedUserName = task.assignedUser.firstName + ' ' + task.assignedUser.lastName

        this.taskDetail = task
        callback(task)
      } else {
        console.log('Nothing from query')
      }
    })
  }

  @action loadPartnerTasks(id) {
    let query = `{
      partnerTasks(
        partnerId: ${ id },
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        task
        dueDate
        partner {
            firstName
            lastName
          }
        taskPriority {
          name
        }
        taskState {
          name
        }
        user {
          firstName
          lastName
        }
        assignedUserId
        assignedUser {
          firstName
          lastName
        }
        createdAt
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.tasks = data.partnerTasks.map((task) => {
        let dd = new Date(task.dueDate)
        task.formattedDueDate =   ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
        let cd = new Date(task.createdAt)
        task.formattedCreatedDate =   ('0' + (cd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (cd.getUTCDate())).slice(-2) + '-' + cd.getUTCFullYear()
        if (task.partner != null) {
          task.partnerName = task.partner.firstName + ' ' + task.partner.lastName
        }
        task.userFullName = task.user.firstName + ' ' + task.user.lastName
        task.assignedUserName = task.assignedUser.firstName + ' ' + task.assignedUser.lastName
        task.priority = task.taskPriority.name
        task.state = task.taskState.name
        return task
      })
    })
  }

  @action addPartnerTask(row, callback) {
    this.ds.query(`mutation {
      addPartnerTask(
        partnerId: ${ row.partnerId },
        userId: ${ row.userId },
        assignedUserId: ${ row.assignedUserId },
        newAssigned: ${ row.newAssigned },
        taskPriorityId: ${ row.taskPriorityId },
        dueDate: "${ row.dueDate }",
        task: "${ row.task }",
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
      }
    }`, (data) => {
      this.loadPartnerTasks(row.partnerId)

      if (callback) {
        callback(data)
      }
    })
  }

  @action updatePartnerTask(row) {
    let query = `mutation {
      updatePartnerTask(
        id: ${ row.id },
        assignedUserId: ${ row.assignedUserId },
        newAssigned: ${ row.newAssigned },
        taskPriorityId: ${ row.taskPriorityId },
        taskStateId: ${ row.taskStateId },
        dueDate: "${ row.dueDate }",
        task: "${ row.task }",
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        partnerId
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.loadPartnerTasks(row.partnerId)
    })
  }
}

export default new Partners()



// WEBPACK FOOTER //
// ./src/stores/partners.js